var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20328 8.36719L14.3302 2.25586C14.4162 2.1543 14.3439 2 14.2111 2H12.6525C12.5607 2 12.4728 2.04102 12.4123 2.11133L8.18375 7.15234L3.95523 2.11133C3.89664 2.04102 3.80875 2 3.715 2H2.15641C2.02359 2 1.95133 2.1543 2.03727 2.25586L7.16422 8.36719L2.03727 14.4785C2.01802 14.5012 2.00566 14.5288 2.00168 14.5583C1.9977 14.5877 2.00225 14.6177 2.01479 14.6446C2.02734 14.6716 2.04735 14.6944 2.07245 14.7103C2.09755 14.7262 2.12669 14.7345 2.15641 14.7344H3.715C3.8068 14.7344 3.89469 14.6934 3.95523 14.623L8.18375 9.58203L12.4123 14.623C12.4709 14.6934 12.5587 14.7344 12.6525 14.7344H14.2111C14.3439 14.7344 14.4162 14.5801 14.3302 14.4785L9.20328 8.36719Z",
    fill: "#DEE2E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fd4961f47fc2e139acdabdebbbfe3e8d.svg";
export { ForwardRef as ReactComponent };